import { createFileRoute } from '@tanstack/react-router';
import CreateExperience from '~/containers/Experiences/CreateExperience';

export const Route = createFileRoute('/experiences/new')({
  component: CreateExperience,
});
